import { ComponentType } from "react"
import { With } from "../common/componentExtensions"

import Store from "./tipiLocaleStore"
import Actions from "./tipiLocaleActions"

export let withTipiLocale = <TProps extends {}>(cmp: ComponentType<TProps>) => With(cmp, Store, () => Actions.getAll());